import { SellerProperties } from '../store/seller/seller-properties';
import { useSelector } from 'react-redux';

export const useIsSellerInTrial = () => {
  const { isInTrial } = useSelector((state) => new SellerProperties({ state }));
  return isInTrial;
};

// The below is useful when a consumer doesn't have access to an updated Redux store
export const useIsSellerInTrialFromSubscriptionPlanInfo = (subscriptionPlanInfo) => {
  if (!subscriptionPlanInfo) {
    return false;
  }

  if (subscriptionPlanInfo.code && subscriptionPlanInfo.code.toLowerCase() !== 'trial') {
    return false;
  }

  if (subscriptionPlanInfo.isExpired === undefined || subscriptionPlanInfo.isExpired === null) {
    return false;
  }

  return !subscriptionPlanInfo.isExpired;
};
